import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const token = localStorage.getItem("token");
const resetToken = localStorage.getItem("resetToken");
let parsedUser = null;
try {
  const rawUser = localStorage.getItem("user");
  if (rawUser && rawUser !== "undefined") {
    parsedUser = JSON.parse(rawUser);
  }
} catch (err) {
  console.log("Invalid JSON in localStorage for user:", err);
}

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: token || "",
    user: parsedUser,
    resetToken: resetToken || null, // 🆕 add this
    userData: {
      photoURL: null, // 🆕 add this
      userName: null,
    }
  },

  reducers: {
    login(state, action) {
      state.token = action.payload;
      state.user = action.payload;
    },
    logout(state) {
      state.token = "";


    },
    updateUser(state, action) {
      state.user = action.payload;
    },
    setResetToken(state, action) {
      state.resetToken = action.payload;
    },
    clearResetToken(state) {
      state.resetToken = null;
    },
    setPhotoURL(state, action) {
      state.userData.photoURL = action.payload;
    },
    setUserName(state, action) {
      state.userData.userName = action.payload;
    },
  }
});

export const { login, logout, updateUser, setResetToken, clearResetToken, setPhotoURL, setUserName } = authSlice.actions;

export default authSlice.reducer;
